(ns common.schema.entities.workspace.kyc.templates.template-registry
  (:require
   [clojure.set :as set]
   [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]
   [common.schema.entities.workspace.kyc.templates.capman.legal-entity :as capman-le]
   [common.schema.entities.workspace.kyc.templates.capman.legal-entity-CWS :as capman-le-CWS]
   [common.schema.entities.workspace.kyc.templates.capman.natural-person :as capman-np]
   [common.schema.entities.workspace.kyc.templates.capman.natural-person-CWS :as capman-np-CWS]
   [common.schema.entities.workspace.kyc.templates.capman.tenant :as capman-tenant]
   [common.schema.entities.workspace.kyc.templates.capman.contract :as capman-contract]
   [common.schema.entities.workspace.kyc.templates.demo.legal-entity :as demo-le]
   [common.schema.entities.workspace.kyc.templates.demo.natural-person :as demo-np]
   [common.schema.entities.workspace.kyc.templates.demo.tenant :as demo-tenant]
   [common.schema.entities.workspace.kyc.templates.innovestor.legal-entity-cofund-angel-entity :as innovestor-le-cofund-angel-entity]
   [common.schema.entities.workspace.kyc.templates.innovestor.legal-entity-cofund-angel-individual :as innovestor-le-cofund-angel-individual]
   [common.schema.entities.workspace.kyc.templates.innovestor.legal-entity-cofund-target-company :as innovestor-le-cofund-target-company]
   [common.schema.entities.workspace.kyc.templates.lifeline.legal-entity :as lifeline-legal-entity]
   [common.schema.entities.workspace.kyc.templates.templates :as templates]))

(def legal-entity-templates
  {:kyc-template/legal-entity                           capman-le/schema
   :kyc-template/legal-entity-CWS                       capman-le-CWS/schema
   :kyc-template/demo-legal-entity                      demo-le/schema
   :kyc-template/innovestor-cofund-angel-target-company innovestor-le-cofund-target-company/schema
   :kyc-template/innovestor-cofund-angel-entity         innovestor-le-cofund-angel-entity/schema
   :kyc-template/innovestor-cofund-angel-individual     innovestor-le-cofund-angel-individual/schema
   :kyc-template/lifeline-legal-entity                  lifeline-legal-entity/schema})

(def natural-person-templates
  {:kyc-template/natural-person      capman-np/schema
   :kyc-template/natural-person-CWS  capman-np-CWS/schema
   :kyc-template/demo-natural-person demo-np/schema})

(def tenant-templates
  {:kyc-template/demo-tenant demo-tenant/schema
   :kyc-template/tenant      capman-tenant/schema})

(def contract-templates
  {:kyc-template/capman-contract capman-contract/schema})

(defn cws-template?
  [kyc-template]
  (contains? #{:kyc-template/legal-entity-CWS :kyc-template/natural-person-CWS} kyc-template))

(defn angel-co-investment-template?
  [kyc-template]
  (contains? #{:kyc-template/innovestor-cofund-angel-target-company
               :kyc-template/innovestor-cofund-angel-entity
               :kyc-template/innovestor-cofund-angel-individual} kyc-template))

(def templates
  (merge legal-entity-templates
         natural-person-templates
         tenant-templates
         contract-templates))

(def template-keys
  (keys templates))

(defn missing-signer?
  [template answers]
  (cond
    ;; TENANT
    (some #{template} [:kyc-template/tenant :kyc-template/demo-tenant])
    (or (empty? (:kyc-tenant/signer-email-1 answers))
        (and (= :two (:kyc-tenant/number-of-signers answers))
             (empty? (:kyc-tenant/signer-email-2 answers))))

    ;; CONTRACT
    (some #{template} [:kyc-template/capman-contract])
    (or (empty? (:contract-kyc/signer-email-1 answers))
        (and (= :two (:contract-kyc/number-of-signers answers))
             (empty? (:contract-kyc/signer-email-2 answers))))

    ;; LEGAL ENTITY
    (some #{template} [:kyc-template/legal-entity :kyc-template/legal-entity-CWS
                       :kyc-template/demo-legal-entity])
    (or (empty? (:kyc-legal-entity/signer-email-1 answers))
        (and (= :two (:kyc-legal-entity/number-of-signers answers))
             (empty? (:kyc-legal-entity/signer-email-2 answers))))

    ;; INNOVESTOR LEGAL ENTITY
    (some #{template} [:kyc-template/innovestor-cofund-angel-entity :kyc-template/innovestor-cofund-angel-target-company])
    (empty? (:kyc-legal-entity/signer-email-1 answers))

    ;; NATURAL PERSON
    (some #{template} [:kyc-template/natural-person :kyc-template/natural-person-CWS
                       :kyc-template/demo-natural-person
                       :kyc-template/innovestor-cofund-angel-individual])
    (empty? (:kyc-person/signer-email answers))
    :else
    (assert (some #{template} template-keys))))

(defn export-schema-from-template
  [template]
  (merge {:export-name (:kyc-template/template-name template)}
         (kyc-utils/schema-export-questions template)))

(defn export-schema
  [template-kw]
  (let [template (templates template-kw)]
    (assoc (export-schema-from-template template)
           :export-template
           {:template  template-kw
            :data/type :data.type/keyword})))

(defn resolve-data-template
  [edn-type [q question-meta]]
  (when (= edn-type (:edn-data/type question-meta))
    (assoc (:data/template question-meta)
           :export-question
           {:question  q
            :data/type :data.type/keyword})))

(defn resolve-export-schemas
  [template-kws]
  (let [legal-kws (set/intersection templates/legal-entity-template-keys (set template-kws))
        legal-schemas (->> legal-kws
                           (map export-schema))
        legal-export-schema (-> (apply merge legal-schemas)
                                (assoc :export-templates
                                       (->> legal-schemas
                                            (map :export-template)
                                            (map :template)
                                            (set)))
                                (dissoc :export-template))
        natural-kws (set/intersection templates/natural-person-templates-keys (set template-kws))
        natural-schemas (->> natural-kws
                             (map export-schema))
        natural-export-schema (-> (apply merge natural-schemas)
                                  (assoc :export-templates
                                         (->> natural-schemas
                                              (map :export-template)
                                              (map :template)
                                              (set)))
                                  (dissoc :export-template))
        board-member-templates
        (concat (->> legal-export-schema
                     (keep (partial resolve-data-template :edn-data.type/board-members-list)))
                (->> natural-export-schema
                     (keep (partial resolve-data-template :edn-data.type/board-members-list))))
        board-member-export-schema (-> (->> board-member-templates
                                            (map export-schema-from-template)
                                            (apply merge))
                                       (assoc :export-questions
                                              (->> board-member-templates
                                                   (map :export-question)
                                                   (map :question)
                                                   (set)))
                                       (dissoc :export-question))

        ubo-templates (concat (->> legal-export-schema
                                   (keep (partial resolve-data-template :edn-data.type/ubo-list)))
                              (->> natural-export-schema
                                   (keep (partial resolve-data-template :edn-data.type/ubo-list))))
        ubo-export-schema (-> (->> ubo-templates
                                   (map export-schema-from-template)
                                   (apply merge))
                              (assoc :export-questions
                                     (->> ubo-templates
                                          (map :export-question)
                                          (map :question)
                                          (set)))
                              (dissoc :export-question))
        pep-templates (concat (->> legal-export-schema
                                   (keep (partial resolve-data-template :edn-data.type/pep-list)))
                              (->> natural-export-schema
                                   (keep (partial resolve-data-template :edn-data.type/pep-list))))
        pep-export-schema (-> (->> pep-templates
                                   (map export-schema-from-template)
                                   (apply merge))
                              (assoc :export-questions
                                     (->> pep-templates
                                          (map :export-question)
                                          (map :question)
                                          (set)))
                              (dissoc :export-question))]
    (->> [legal-export-schema natural-export-schema board-member-export-schema ubo-export-schema
          pep-export-schema]
         (remove nil?))))
